import React from 'react';
import LearningCard from '../components/LearningCard';

const Nike1Year = () => (
  <LearningCard
    testid="nike-1-year"
    logoSrc="/logo-nike.jpg"
    logoAlt="Nike"
    logoRound={false}
    title="Nike 1 Year Celebration"
    subtitle="Hospitality & Store Briefing"
    support={[
      'Over the Pentecost weekend, Nike celebrates its first anniversary in the Village since the reopening. To mark the occasion, a special activation will run from 23 to 25 May at the Village Bike, positioned outside the Nike boutique.',
      'Guests who spend a minimum of €80 at Nike will receive a voucher at the till. They can exchange this voucher at the Village Bike for one healthy snack or one infused drink, subject to daily availability.',
      'In this microlearning, you’ll learn how the activation works, what your role is as part of the Nike staffing team, the Village Bike Host team or the Village Host team, and how to support a smooth and welcoming guest experience.',
      'The visual direction follows the Nike 1 Year moodboard, with branded snacks, banana bread and infused waters presented in a clean, celebratory style.',
    ]}
    buttons={[
      {
        label: 'Open the microlearning',
        href: 'https://app.qoldo.com/p/68dac033-78a4-49de-8eb2-c71050a3a023?t=ae249185-1d96-4803-a2e9-9f3b4c72ab0d',
        testid: 'btn-open-microlearning',
      },
    ]}
  />
);

export default Nike1Year;
